import 'jquery-zoom'
import './sort.js'

let popsheet = $('.popsheet');

window.slickPopupRev = () => {
    $('.reviewPopupSlider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        infinite: true,
        centerMode: true
    })
}

window.navSlickPopupRev = (idx) => {
    $('.reviewPopupSlider').slick('slickGoTo', idx, true)
}

window.openTabdetails = (el, evt, cityName) => {
    var details = document.querySelector('.detailContent')
    var i, tablinkcontent, tabbutton
    tablinkcontent = details.querySelectorAll(".tabcontent")

    for (i = 0; i < tablinkcontent.length; i++) {
        tablinkcontent[i].classList.remove("active")
    }

    const tabbuttonparent = el.parentNode
    tabbutton = details.querySelectorAll(".tabItem")

    for (i = 0; i < tabbutton.length; i++) {
        tabbutton[i].className = tabbutton[i].className.replace(" active", "")
    }

    document.getElementById(cityName).classList.add("active")
    tabbuttonparent.className += " active"
}

window.inc = (el, max) => {
    let qty = el.parentNode.querySelector('[name="qty"]'),
        buttons = el.parentNode.querySelectorAll('button')
    
    qty.value = parseInt(qty.value) + 1

    buttons.forEach((button) => {
        button.classList.remove('disable')
    })

    if (qty.value >= parseInt(max)) {
        qty.value = max;
        el.classList.add('disable')
    }

    var priceType = $('#price-type').val();
    if (priceType == 3) {
        $.ajax({
            type: 'POST',
            url: BASE_URL + '/wholesales_price',
            data: {
                wholesales_qty: qty.value,
                product_id: $('#product_id').val(),
            },
            dataType: "html",
            success: (result) => {
                let summaryAmount = result * qty.value;
                $('#summaryAmount').text('Rp' + Intl.NumberFormat('id-ID').format(parseInt(summaryAmount)));
                $('.detailPrice').text('Rp' + Intl.NumberFormat('id-ID').format(parseInt(result)));
            },
            error: function() {
                console.log('error');
            }
        });
    }else if(priceType == 2){
        // var variantId = $('input[name="type"]:checked').val();
        var variantId = $('input[name="priceVariant"]:checked').attr('data-varianid');
        $.ajax({
            type: 'POST',
            url: BASE_URL + '/variant_price',
            data: {
                variant_id: variantId,
                product_id: $('#product_id').val(),
            },
            dataType: "html",
            success: (result) => {
                let summaryAmount = result * qty.value;
                $('#summaryAmount').text('Rp' + Intl.NumberFormat('id-ID').format(parseInt(summaryAmount)));
            },
            error: function() {
                console.log('error');
            }
        });
    
    }else{
        let summaryAmount = $('#price').val() * qty.value;
        $('#summaryAmount').text('Rp' + Intl.NumberFormat('id-ID').format(parseInt(summaryAmount)));
    }
}

window.dec = (el, min) => {
    let qty = el.parentNode.querySelector('[name="qty"]'),
        buttons = el.parentNode.querySelectorAll('button')

    qty.value = parseInt(qty.value) - 1;
    
    buttons.forEach((button) => {
        button.classList.remove('disable')
    })

    if (qty.value <= parseInt(min)) {
        qty.value = min;
        el.classList.add('disable')
    }

    var priceType = $('#price-type').val();
    if (priceType == 3) {
        $.ajax({
            type: 'POST',
            url: BASE_URL + '/wholesales_price',
            data: {
                wholesales_qty: qty.value,
                product_id: $('#product_id').val(),
            },
            dataType: "html",
            success: (result) => {
                let summaryAmount = result * qty.value;
                $('#summaryAmount').text('Rp' + Intl.NumberFormat('id-ID').format(parseInt(summaryAmount)));
                $('.detailPrice').text('Rp' + Intl.NumberFormat('id-ID').format(parseInt(result)));
            },
            error: function() {
                console.log('error');
            }
        });
    }else if(priceType == 2){
        var variantId = $('input[name="priceVariant"]:checked').attr('data-varianid');
        $.ajax({
            type: 'POST',
            url: BASE_URL + '/variant_price',
            data: {
                variant_id: variantId,
                product_id: $('#product_id').val(),
            },
            dataType: "html",
            success: (result) => {
                let summaryAmount = result * qty.value;
                $('#summaryAmount').text('Rp' + Intl.NumberFormat('id-ID').format(parseInt(summaryAmount)));
            },
            error: function() {
                console.log('error');
            }
        });
    
    }else{
        let summaryAmount = $('#price').val() * qty.value;
        $('#summaryAmount').text('Rp' + Intl.NumberFormat('id-ID').format(parseInt(summaryAmount)));
    }
}

window.updateCartPos = () => {
    var viewport = $(window).width()
    if (viewport >= 1230) {
        $('.-jsSummaryTg').appendTo('#cartDesk')
        if (!!popsheet) {
            popsheet.appendTo('#sumDesk')
            popsheet.removeClass('mobile')
        }
    } else {
        $('.-jsSummaryTg').appendTo('#cartMob');
        if (!!popsheet) {
            popsheet.appendTo('#sumMob');
            popsheet.addClass('mobile');
        }
    }
}

window.checkAllCart = (el) => {
    let checks = el.parentNode.querySelectorAll('[type="checkbox"]')

    checks.forEach((check) => {
        check.checked = el.checked ? false : true
    })
    el.checked = !el.checked
}

// setWishlist mthod POST
// window.setWishlist = (el, productId, status) => {
//     const member = $('#member_id').val()
//     if(!member) return window.location = BASE_URL + '/login'

//     $.ajax({
//         type: "POST",
//         url: BASE_URL + '/product/wishlist/' + productId,
//         data: {
//             status: status
//         }
//     })
//     .done((response) => $('.list-wishlist').html(response))
//     .fail((xhr, textStatus, errorThrown) => console.log(errorThrown))
// }

window.setWishlist = (el, productId, status) => {
    $.ajax({
        type: "GET",
        url: BASE_URL + '/product/wishlist/' + productId + '/' + status,
    })
    .done((response) => $('.list-wishlist').html(response))
    .fail((xhr, textStatus, errorThrown) => {
            return window.location   = BASE_URL + '/login';
        }
    )
}

window.product = function () {
    const applyFilter = () =>
        $("#form-category").submit(function(e) {
            e.preventDefault()
            const form = $(this)
            $.ajax({
                type: "GET",
                url: form.attr('action'),
                data: form.serialize(),
                success: function (data) {
                    window.history.replaceState({}, document.title, this.url)
                    
                    $('#list-ajax').html(data)
                    $('html, body').animate({
                        scrollTop: $("#list-ajax").parent().parent().offset().top
                    }, 1000)
                }
            })
            .fail((xhr, textStatus, errorThrown) => console.log(errorThrown))
        })
    
    const resetFilter = () =>
        $("#rstFilter").click(function(e) {
            document.querySelectorAll('.formCheck')
                .forEach((item) => {
                    item.checked = false
                })
    
            if(document.getElementById('pricemin')) 
            document.getElementById('pricemin').value = null
    
            if(document.getElementById('pricemax')) 
            document.getElementById('pricemax').value = null
    
            $('input:radio[name="order"]').filter('[value="created_at.desc"]').attr('checked', true)
            $("#form-category").submit()
        })

    const sort = () => {
        $(document).on('change', '#sort-filter', function(e) {
            $('input[name=order]').prop('checked', false)
            e.preventDefault();

            let order = $(this).val(),
                url = window.location.href.split('?')[0]
                url += '?page=1'

            $("input[name=order][value='" + order + "']").prop('checked', true)
            $('#form-category').attr('action', url).submit()
        })

        $(document).on('click', '#btn-submit-category', function(event) {
            event.preventDefault()

            let url = window.location.href.split('?')[0]
            url += '?page=1'

            $('#form-category').attr('action', url).submit()
        })
    }

    const paging = () => 
        $(document).on('click', '#pagination-product a', function(event) {
            event.preventDefault()
           
            const url = $(this).attr('href')

            $('#form-category').attr('action', url).submit()
        
            return false
        })

    return {
        init: function() {
            applyFilter()
            resetFilter()
            sort()
            paging()
        }
    }
}()

window.productDetil = function () {
    const slickImg = () => {
        $('.detailImageList').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            infinite: true,
            asNavFor: '.detailImageNav'
        })

        $('.detailImageNav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.detailImageList',
            arrows: true,
            dots: false,
            centerMode: false,
            infinite: true,
            focusOnSelect: true
        })
        
        if ($('.detailImage--small').length > 5)
            $('.detailImageNav .slick-arrow').addClass('visible')
        else
            $('.detailImageNav .slick-arrow').addClass('hidden')
    }

    const slickIndex = () => {
        $(':radio[name="priceVariant"]').change(function () {
            var type = $(this).filter(':checked').val();
            $(".detailImageNav").slick('slickGoTo', type, true);
        })
    }

    const zoom = () => 
        $('.-zoom').each(function () {
            const src = $(this).find('img').attr('data-zoom')
            $(this).zoom({
                url: src,
                on: 'mouseover',
                duration: 50
            })
        })

    window.priceType = (variantId) => {
        var priceType = $('#price-type').val();
        //get value first select variant
        if (priceType == 2) {
            //set stock first select
            $.ajax({
                type: 'POST',
                url: BASE_URL + '/stock-variant',
                data: {
                    variant_id: variantId,
                },
                dataType: "html",
                success: (result) => {
                    $('.qtyAmount').html('Stok : ' + result);
                    $('.product-stock').val(result);
                    $('.variant-qty').val(result);
                    $.ajax({
                        type: 'POST',
                        url: BASE_URL + '/variant_price',
                        data: {
                            variant_id: variantId,
                            product_id: $('#product_id').val(),
                        },
                        dataType: "html",
                        success: (result) => {
                            $(".variant-stock-qty").load(location.href + " .variant-stock-qty");
                            let summaryAmount = result;
                            $('#summaryAmount').text('Rp' + Intl.NumberFormat('id-ID').format(parseInt(summaryAmount)));
                            $('.detailPrice').text('Rp' + Intl.NumberFormat('id-ID').format(parseInt(result)));
                        },
                        error: function() {
                            console.log('error');
                        }
                    });
                },
                error: function() {
                    console.log('error');
                }
            });
        }
    }

    const addCart = () =>
        $('#btnAddCart').click(function(e) {
            e.preventDefault()

            var priceType = $('#price-type').val();

            if($('#stock').val() > 0){
                if (priceType == 2) {
                    var variantId = $('input[name="priceVariant"]:checked').attr('data-varianid');
                    if (variantId != 0) {
                        $.ajax({
                            type: 'POST',
                            url: BASE_URL + '/api/cart-store',
                            data: {
                                qty: $('#qty').val(),
                                product_id: $('#product_id').val(),
                                product_price_id: variantId,
                                store_id: $('#store_id').val(),
                                member_id: $('#member_id').val(),
                            },
                            success: (data) => {
                                $('#addcart-notif-success').removeAttr("style")
                                window.setTimeout(() => location.reload(), 1000)
                            },
                            error: function() {
                                window.location.href = BASE_URL + '/login';
                                // console.log('add to cart error');
                            }
                        });
                    }else{
                        $('#stock-notif-error').removeAttr("style");
                    }
                    
                } else if(priceType == 3) {
                    $.ajax({
                        type: 'POST',
                        url: BASE_URL + '/api/cart-store',
                        data: {
                            qty: $('#qty').val(),
                            product_id: $('#product_id').val(),
                            product_price_id: $('#product_price_id').val(),
                            store_id: $('#store_id').val(),
                            member_id: $('#member_id').val(),
                        },
                        success: (data) => {
                            $('#addcart-notif-success').removeAttr("style")
                            window.setTimeout(() => location.reload(), 1000)
                        },
                        error: function() {
                            window.location.href = BASE_URL + '/login';
                        }
                    });
                } else {
                    $.ajax({
                        type: 'POST',
                        url: BASE_URL + '/api/cart-store',
                        data: {
                            qty: $('#qty').val(),
                            product_id: $('#product_id').val(),
                            product_price_id: $('#product_price_id').val(),
                            store_id: $('#store_id').val(),
                            member_id: $('#member_id').val(),
                        },
                        success: (data) => {
                            $('#addcart-notif-success').removeAttr("style")
                            window.setTimeout(() => location.reload(), 1000)
                        },
                        error: function() {
                            window.location.href = BASE_URL + '/login';
                        }
                    });
                }
            }else{
                $('#stock-notif-error').removeAttr("style");
            }
            
        })
    
    const checkout = () => 
        $('#btnCheckout').click(function(e) {
            e.preventDefault();

            var priceType = $('#price-type').val();

            if($('#stock').val() > 0){
                var qty = $('#qty').val();
                var productId = $('#product_id').val();
                var productPriceId = $('#product_price_id').val();
                var storeId = $('#store_id').val();
                var memberId = $('#member_id').val();

                if (priceType == 2) {
                    var variantId = $('input[name="priceVariant"]:checked').attr('data-varianid');
                    if (variantId != 0) {
                        $.ajax({
                            type: 'POST',
                            url: BASE_URL + '/cart-checkout',
                            data: {
                                qty: qty,
                                product_id: productId,
                                product_price_id: variantId,
                                store_id: storeId,
                                member_id: memberId,
                            },
                            success: function(data) {
                                window.location.href = BASE_URL + '/checkout';
                            },
                            error: function() {
                                window.location.href = BASE_URL + '/login';
                            }
                        });
                    }else{
                        $('#stock-notif-error').removeAttr("style");
                    }
                } else if(priceType == 3) {
                    $.ajax({
                        type: 'POST',
                        url: BASE_URL + '/cart-checkout',
                        data: {
                            qty: qty,
                            product_id: productId,
                            product_price_id: productPriceId,
                            store_id: storeId,
                            member_id: memberId,
                        },
                        success: function(data) {
                            window.location.href = BASE_URL + '/checkout';
                        },
                        error: function() {
                            window.location.href = BASE_URL + '/login';
                        }
                    });
                } else {
                    $.ajax({
                        type: 'POST',
                        url: BASE_URL + '/cart-checkout',
                        data: {
                            qty: qty,
                            product_id: productId,
                            product_price_id: productPriceId,
                            store_id: storeId,
                            member_id: memberId,
                        },
                        success: function(data) {
                            window.location.href = BASE_URL + '/checkout';
                        },
                        error: function() {
                            window.location.href = BASE_URL + '/login';
                        }
                    });
                }
            }else{
                $('#stock-notif-error').removeAttr("style");
            }
        })


    const chartpos = () =>
        $(window).on('resize', function() {
            window.updateCartPos()
        })

    return {
        init: function() {
            slickImg()
            slickIndex()
            addCart()
            checkout()
            zoom()
            chartpos()
            window.setShareLinks()
            // priceType()
        }
    }
}()

jQuery(function() {
    window.setMaxheight()
    window.updateCartPos()
})